import { CompanyCamProjectEditor } from "@/react/components/entityViews/files/components/editors/CompanyCamProjectEditor";
import { MoreMenu, MenuItem } from "@/modern/components/more-menu";
import { UploadFileMenuButton } from "./UploadFileMenuButton";
import { CameraIcon, FilesIcon } from "lucide-react";
import { useEntityFileContext } from "@/react/components/entityViews/files/context/EntityFileContext";
import { ButtonGroup } from "@/modern/components/ui/button-group";
import { EDITOR_KEYS } from "@/other/constants/EditorKeys";
import { useSwivuBryntumContext } from "@/react/hooks/useSwivuBryntumContext";

export const FileMenu = () => {
  const { entityRecord } = useEntityFileContext();
  const { editorHandler } = useSwivuBryntumContext();

  const menuItems: MenuItem[] = [
    {
      itemVariant: "button" as const,
      menuText: "View all files",
      dropdownMenuItemProps: {
        onClick: () => {
          editorHandler.openEditor(EDITOR_KEYS.taskFilesEditor, entityRecord, { task: entityRecord });
        }
      },
      Component: () => {
        return (
          <button className="flex items-center gap-2 w-full cursor-default">
            <FilesIcon className="size-4 mr-1" />
            View all files
          </button>
        );
      }
    },
    {
      itemVariant: "modal" as const,
      variant: "title" as const,
      menuText: "Link Company Cam",
      Icon: CameraIcon,
      Component: CompanyCamProjectEditor,
      modalTitle: "Link company cam project",
      menuItemModalHeaderVariant: "title" as const
    }
  ];

  return (
    <ButtonGroup>
      <UploadFileMenuButton record={entityRecord} />
      <MoreMenu menuItems={menuItems} record={entityRecord} menuTitle="Files" triggerButtonVariant={"entityHeader"} />
    </ButtonGroup>
  );
};
